import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'index',
		component: () => import('../views/index.vue')
	},
	{
		path: '/about',
		name: 'about',
		component: () => import( /* webpackChunkName: "about" */ '../views/about/index.vue')
	},
	{
		path: '/hardware',
		name: 'hardware',
		component: () => import( /* webpackChunkName: "about" */ '../views/hardware/index.vue')
	},
	{
		path: '/hardware/detail',
		name: 'hardware/detail',
		component: () => import( /* webpackChunkName: "about" */ '../views/hardware/details/_id.vue')
	},
	{
		path: '/solution',
		name: 'solution',
		component: () => import( /* webpackChunkName: "about" */ '../views/solution/_type.vue')
	},
	{
		path: '/solution/detail',
		name: '/solution/detail',
		component: () => import( /* webpackChunkName: "about" */ '../views/solution/details/_id.vue')
	},
	{
		path: '/cases/schoolCase',
		name: '/cases/schoolCase',
		component: () => import( /* webpackChunkName: "about" */ '../views/cases/schoolCase.vue')
	},
	{
		path: '/cases/detail',
		name: '/cases/detail',
		component: () => import( /* webpackChunkName: "about" */ '../views/cases/details/_id.vue')
	}



]

const router = new VueRouter({
	routes
})

export default router
